export default "__VITE_ASSET__933a1b38__"